import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { get, replace, toLower } from 'lodash';
import { Observable, of } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
// Service
import { PartSearchService } from '../../partsearch-shared-module/service';
// Transloco
import { TranslocoService } from '@jsverse/transloco';

export const ProductDetailsResolverService: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> => {
    const partSearchService = inject(PartSearchService);
    const router = inject(Router);
    const translocoService = inject(TranslocoService);

    const sourcePath: string = get(route, 'data.path', 'S1');
    const id = Number(replace(toLower(get(route, 'params.id', '')), 'id-', ''));
    const params = { id, sourcePath };

    return partSearchService.getProductDetails(params).pipe(
        take(1),
        tap((response: any) => {
            const lang = translocoService.getActiveLang();

            // If the response indicates access is forbidden, redirect to the 403 error page
            if (response?.status === 403) {
                router.navigate(['/', lang, 'error', '403'], { replaceUrl: true });
                throw new Error('Redirecting to error 403 page.');
            }

            // If the response indicates a captcha is required, redirect to the captcha page
            if (response?.status === 422) {
                const returnUrl = state.url !== '/' ? state.url : undefined;
                router.navigate(['/', lang, 'captcha'], {
                    replaceUrl: true,
                    queryParams: {
                        returnUrl: returnUrl
                    }
                });
                throw new Error('Redirecting to captcha page.');
            }
        }),
        catchError(() => of([]))
    );
};
